export const WIDGET_STATE = {
    OPENED: Symbol('opened'),
    CLOSED: Symbol('closed'),
    INIT: Symbol('init'),
    EMBEDDED: Symbol('embedded'),
};
